import { registerDe } from '../i18n/index.js';

registerDe({
  'Writing profile': 'Schreibprofil',
  'How this person and the operator actually write to each other: counts in and out, median reply hours and word counts either side, the greeting and sign-off verbatim, and the register the evidence supports. Every value reads "not collected" until there are at least two messages — a profile guessed from one mail is worse than no profile.': 'Wie diese Person und die Operatorin einander tatsächlich schreiben: Anzahl ein- und ausgehend, Median der Antwortzeit und Wortzahl auf beiden Seiten, Anrede und Grussformel wörtlich, und die Anredeform, die die Belege stützen. Jeder Wert steht auf „nicht erhoben“, solange weniger als zwei Nachrichten vorliegen — ein aus einer einzigen Mail geratenes Profil ist schlechter als gar keines.',

  'The writing profile could not be read.': 'Das Schreibprofil konnte nicht gelesen werden.',
  'Reading the correspondence…': 'Der Schriftwechsel wird gelesen…',
  'messages': 'Nachrichten',
  'from them': 'von ihnen',
  'from you': 'von Ihnen',
  'rhythm': 'Rhythmus',
  'you answer in': 'Sie antworten in',
  'they answer in': 'sie antworten in',
  'median': 'Median',
  'h': 'Std.',
  'length': 'Länge',
  'yours': 'Ihre',
  'theirs': 'ihre',
  'words': 'Wörter',
  'greeting': 'Anrede',
  'sign-off': 'Grussformel',
  'verbatim, your own': 'wörtlich, Ihre eigene',
  'no greeting on record': 'keine Anrede erfasst',
  'no sign-off on record': 'keine Grussformel erfasst',
  'register': 'Anredeform',
  'formal (Sie / vous)': 'förmlich (Sie / vous)',
  'familiar (du / tu)': 'vertraut (du / tu)',
  'German': 'Deutsch',
  'French': 'Französisch',
  'English': 'Englisch',
  'Italian': 'Italienisch',
  'read from their own lines; nobody has held it': 'aus ihren eigenen Zeilen gelesen; niemand hat es übernommen',
  '{n} lines': '{n} Zeilen',
  'no evidence': 'kein Beleg',
  'Fewer than two messages with this person are on the record, so nothing above was measured. Every value reads "not collected" rather than zero: a profile guessed from one mail would send the next draft out in the wrong voice.':
    'Es sind weniger als zwei Nachrichten mit dieser Person erfasst, also wurde oben nichts gemessen. Jeder Wert steht auf „nicht erhoben“ statt auf null: Ein aus einer einzigen Mail geratenes Profil würde den nächsten Entwurf im falschen Ton verschicken.',
}, 'WritingProfile');
